import React, { useEffect } from "react";
import { useStore } from "../../../store/store";

function usePanelWidthInputSelector(isPivot: boolean, overall: number) {
  const handleErrMsgChange = useStore((state) => state.handleError);
  const errors = useStore((state) => state.errors);
  const stilesAndRailsCategory = useStore((state) => state.quote.stilesAndRails);
  const material = useStore((state) => state.quote.material);
  const equalPanels = useStore((state) => state.quote.equalPanels);
  const isAlum = material?.includes("Aluminum");
  const isPico = stilesAndRailsCategory?.includes("Pico");

  useEffect(() => {
;    if (!overall) return;
    let errText = "";

    if (isPivot && !equalPanels) {
      errText = overall < 28 || overall > 96 ? `Between 28" and 96"` : "";
    } else {
      const min = isPivot ? 28 : 24;
      const max = isAlum || isPico? 48 : 42;
      errText =
        overall < min || overall > max ? `Between ${min}" and ${max}"` : "";
    }
    handleErrMsgChange("swingWidthErr", errText);
  }, [overall, stilesAndRailsCategory]);

  return {
    swingWidthErr: errors.swingWidthErr,
    isAlum,
    isPico
  };
}

export default usePanelWidthInputSelector;
